import { mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapState("memberInvites", ["memberInvites"]),
    ...mapGetters("organization", ["organization", "isOrganizationPredictile", "isOrganizationBusiness", "isOrganizationUser"]),
  },
  methods: {
    async redirectToHome() {
      // if (this.memberInvites && this.memberInvites.length && this.$route.path !== `/member-invite/${this.memberInvites[0].businessMemberInviteId}`)
      //   await this.$router.push(`/member-invite/${this.memberInvites[0].businessMemberInviteId}`);
      if (this.isOrganizationPredictile && this.$route.path !== `/businesses/`) await this.$router.push(`/businesses/`);
      else if (this.isOrganizationBusiness && this.$route.path !== `/businesses/${this.organization.id}/home`) await this.$router.push(`/businesses/${this.organization.id}/home`);
      else if (this.isOrganizationUser && this.$route.path !== `/users/${this.organization.id}/plans`) await this.$router.push(`/users/${this.organization.id}/plans`);
      else if (this.$route.path !== "/") await this.$router.push("/");
    },
  },
};
